// src/components/SafetyTipCard.js
import React from "react";
import "../styles/SafetyTipCard.css";
import fallbackImage from "../assets/images/PriniCrackers.jpg";

const SafetyTipCard = ({ icon: Icon, title, text, image }) => {
  return (
    <div className="tip-card">
      <Icon className="tip-icon" />
      <h3>{title}</h3>
      <div
        className="tip-img-wrapper"
        style={{ backgroundImage: `url(${image || fallbackImage})` }}
        aria-label={title}
        role="img"
      ></div>
      <p>{text}</p>
    </div>
  );
};

export default SafetyTipCard;
